/**
 * @architecture-header 1
 * @layer app
 * @domain parallel-development
 * @responsibility Compose Agent B-owned workspace section actions without changing shared routes.
 * @state-owner Agent B feature modules
 * @allowed-imports Agent B module public APIs; shared composition contract
 * @forbidden Agent A modules; routes; direct API clients
 * @public-api WorkspaceSectionActions aggregator
 * @side-effects delegated to rendered feature actions
 * @tests WorkspaceSectionActions.test.tsx and workspace Playwright flows
 */

import type { ReactNode } from 'react';
import { ClassroomCreateAction, ClassroomLifecycleAction } from '../../../modules/classrooms';
import type { WorkspaceSectionActionContext } from '../types';

export function agentBSectionActions(context: WorkspaceSectionActionContext): ReactNode {
  if (context.role !== 'teacher' || context.section !== 'room') return null;
  if (context.surface === 'desktop') {
    return <ClassroomLifecycleAction surface={context.surface} />;
  }
  if (context.surface === 'mobile-detail') {
    return <ClassroomLifecycleAction surface={context.surface} />;
  }
  return (
    <>
      <ClassroomLifecycleAction surface={context.surface} />
      <ClassroomCreateAction surface={context.surface} />
    </>
  );
}
